import { WorldpayCustomisationInputs } from '../../models/worldpay/worldpay-customisation-inputs.interface';
import { mockWorldpayCustomisationBorder } from './worldpay-customisation-border.mock';
import { mockWorldpayCustomisationInteraction } from './worldpay-customisation-interaction.mock';

export const mockWorldpayCustomisationInputs: WorldpayCustomisationInputs = {
  backgroundColor: '#000000',
  border: mockWorldpayCustomisationBorder,
  color: '#000000',
  focus: mockWorldpayCustomisationInteraction,
  fonts: [],
  hover: mockWorldpayCustomisationInteraction,
  placeholder: {
    color: '#000000',
  },
  validation: {
    error: {
      color: '#000000',
    },
    ok: {
      color: '#000000',
    },
  },
};
